import axios from "axios";
import { snack } from "components/toast";
import moment from "moment";
import { setGlobalLoading } from "redux/reducers/globalSlice";
import store from "redux/store";

export const skipurls = [
  "quantum",
  "qtmtest",
  "qtmtest.vider",
  "/notifications/token",
  "/notifications/count",
  "/get-started",
  "/permissions/mine",
  "/users/profile",
  "/users/signin",
];

window["expirydate"] = false;
window["demo"] = false;

const trailExpired = (function () {
  let executed = false;
  let previousArgument = "";

  return function (arg: any) {
    if (!executed || arg !== previousArgument) {
      executed = true;
      previousArgument = arg;
      snack.error("Your Trial Period has expired");
    }
  };
})();

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${localStorage.getItem("token")}` || "",
  },
    withCredentials: true,
});

http.interceptors.request.use(
  function (config) {
    store.dispatch(setGlobalLoading(true));
     // Always send cookies
    config.withCredentials = true;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response: any) {
    const config = response?.data?.organization?.config;

    if (response?.config?.url.includes("users/profile")) {
      let today = moment().format("YYYY-MM-DD");
      const expiryDate = moment(config?.expirydate, "YYYY-MM-DD");

      const duration = moment.duration(expiryDate.diff(today));
      const daysDifference = duration.asDays();

      // console.log('Difference in days:', daysDifference);
      window["expirydate"] = daysDifference <= 0 ? true : false;
      window["demo"] = config?.demo == "yes" ? true : false;
    }

    const skipurl = skipurls.indexOf(response?.config?.baseURL + response?.config?.url) >= 0;

    if (!skipurl && window["expirydate"] && window["demo"]) {
      setTimeout(() => {
        trailExpired(window.location.href);
      }, 1000);

      store.dispatch(setGlobalLoading(false));

      return Promise.reject({ error: "Trail expired" });
    }
    if (
      (config?.subscriptionmode == "monthly" || config?.subscriptionmode == "yearly") &&
      window["expirydate"]
    ) {
      snack.error("Your subscription ended");

      if (!window.location.href.includes("subscription")) {
        window.location.href = "/subscription";
      }
    } else {
      store.dispatch(setGlobalLoading(false));
      return response;
    }
  },
 async function (err) {
    store.dispatch(setGlobalLoading(false));

    if (err.message === "Network Error") {
      alert("Network Error");
    }
    // use for expiry date
    // if (
    //   err.response.data.statusCode === 422
    // ) {
    //   snack.error(err.response.data.message);
    // }
 if (err.response?.status === 401 && !err.config._retry) {
      const originalRequest = err.config;
      // Prevent infinite loop: don't apply logic to refresh endpoint
      if (originalRequest.url.includes("/users/refresh")) {
        return Promise.reject(err);
      }

      err.config._retry = true; // avoid infinite loop
      // try {
      //   // Call backend to refresh token
      //   await http.post("/users/refresh");

      //   // Retry original request with new cookie
      //   return http(err.config);
      // } catch (refreshError) {
      //   // Refresh also failed -> logout
      //   snack.error("Session expired. Please login again.");
      //   localStorage.clear(); // optional, since cookies handle JWT now
      //   window.location.href = "/login";
      //   return Promise.reject(refreshError);
      // }
        localStorage.clear(); // optional, since cookies handle JWT now
        window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
